module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_L-2533.4579cbdd.png";